module.exports = __webpack_public_path__ + "img/demo-school.20a86513.png";